<template>
	<div id="CookiesDisclamer" class="fullSize fullPageStatic">

        <div class="fullPageStatic_close" v-on:click="close"></div>

		<div class="scrollable_content_fullpage fullSize" >

            <h1 class="title_bold">Cookie Policy</h1>

            <p>
                <b>{{currentUrl}}</b>, like many others, uses small files called cookies to help us customize your experience. Our Cookie Policy explains what cookies are, how we use cookies, how third-parties we partner with may use cookies and your choices regarding cookies. 
            </p>

            <h2 class="subtitle">What are cookies</h2>
            <p>
                Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored on your device either temporarily for that session only or permanently on the hard disk (persistent cookie) and allows the website or a third-¬party to recognize you and make your next visit easier and the features more useful to you. 
            </p>

            <h2 class="subtitle">How this site uses cookies</h2>
            <p>
                This website uses cookies which are necessary for functioning of the website by default. These cookies cannot be removed, or the website won’t work. We call these “Essential”. There are also other cookies we use that are not strictly necessary for operating this site, which you can block by changing your browser settings or alternatively choose to not continue browsing the site.
            </p>

            <h2 class="subtitle">Third-party cookies</h2>
            <p>
                In addition to our own cookies (cookies which are served from domain {{currentUrl}}), we may also use various third-party cookies (cookies which are served from anywhere else than from {{currentUrl}}) to report usage statistics of the site and deliver advertisements.
            </p>

            <h2 class="subtitle">What are your choices regarding cookies</h2>
            <p>
                If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser and/or use some of the suggested sites below. Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.
            </p>

            <h2 class="subtitle">More information about cookies</h2>
            <p>
                You can learn more about cookies on following third-¬party websites: 
            </p>
            <p>
                <ul>
                    <li>AllAboutCookies: <a href="http://www.allaboutcookies.org/">allaboutcookies.org</a></li>
                    <li>Network Advertising Initiative: <a href="http://www.networkadvertising.org/">networkadvertising.org</a></li>
                </ul>
            </p>

            <h2 class="subtitle">How you can stop receiving interest-based ads</h2>
            <p>
                <ul>
                    <li>Visit the WebChoices Tool to evaluate your browser’s internet based ads (IBA) settingsand select opt-outs <a href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a></li>
                    <li>Visit the AppChoices page for directions on how to download the AppChoices app and control interest based ads (IBA) on your mobile phone:  <a href="https://www.youradchoices.com/appchoices ">https://www.youradchoices.com/appchoices</a></li>
                </ul>
            </p>
            <p>
                You can also prevent getting interest-based ads on websites by adjusting the ad tracking settings on your device.
            </p>
            <p>
                See below for an overview of the different types of cookies we use on this website when you allow us to.
            </p>

            <h1 class="title_bold">First party cookies</h1>
            <p>Cookies which are served from domain {{currentUrl}} are categorized as First-party cookies. The ones used that fall in this category are:</p>

            <h2 class="subtitle">Essential</h2>

            <p>
                <ul>
                    <li>(Stryker) <b>cookie-cookie-disclaimer</b> - Tracks whether the user has dismissed the cookie disclaimer.</li>
                </ul>
            </p>

            <h1 class="title_bold">Third party cookies</h1>
            <p>
                Third party cookies are served from anywhere else than from {{currentUrl}} are categorized as third-party cookies. The ones used that fall in this category are:
            </p>

            <h2 class="subtitle">Only necessary</h2>
            <p>
                <ul>
                <li>(olark.com) <strong>hblid</strong><br>
                a visitor identifier that Olark, the live chat tool we use, use only to remember this visitor between visits</li>
                <li>(olark.com) <strong>wcsid</strong><br>
                a session identifier that Olark, the live chat tool we use, use only to keep track of a single chat session</li>
                <li>(olark.com) <strong>olfsk</strong><br>
                storage identifier that Olark, the live chat tool we use, use to maintain chat state across pages (e.g. message history)</li>
                <li>(olark.com) <strong>_okdetect</strong>
                used for detecting when storage contexts have changed due to things like ssl or host transitions (helps maintain your chat across pages)</li>
                <li>(olark.com) <strong>_okbk</strong><br>
                extra state information (e.g. chat box being open/closed)</li>
                <li>(olark.com) <strong>_ok</strong><br>
                most recent Olark site ID (security measure)</li>
                <li>(olark.com) <strong>_oklv</strong><br>
                the Olark loader version (for improved caching)</li>
                <li>(olark.com) <strong>_okla</strong><br>
                used for caching purposes (loaded from CDN vs. loaded from our infrastructure)</li>
                <li>(olark.com) <strong>_okgid</strong><br>
                group id the visitor is locked to</li>
                <li>(olark.com) <strong>_okac</strong><br>
                used for caching by setting a hash for assets to determine if they have changed and if they need to be refreshed</li>
                <li>(olark.com) <strong>_okck</strong><br>
                used to test whether the visitor’s browser allows cookies to be stored</li>
                </ul>
            </p>
            <p>
                This cookie statement is published on [08/26/2020]. We work continuously to complete and improve it. We therefore recommend to check this statement regularly to keep abreast of changes.
            </p>

        </div>
	</div>
</template>

<script>
export default {
	name: 'Privacy',
	props: {
		App: Object
	},
	data : function() {
		return {
			currentUrl: 'stryker-virtual.com'
		}
	},
	mounted() {
		
	},
	created() {
	},
	methods : {

        close() {
            this.App.cookiesPageDisplay = false;
        }

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
